import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import SOLogout from "../../components/Logout/SOLogout";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl
} from "@mui/material";
import { Tooltip } from "antd";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
// import FormControl from "@mui/material/FormControl";
// import Input from "@mui/material/Input";
// import InputLabel from "@mui/material/InputLabel";
// import { AiOutlineSearch } from "react-icons/ai";
import { makeStyles } from "@mui/styles";
import Layout from "../../components/Wrappers/Layout";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { getRefunds } from "../../redux/actions/getRefundPartnerAction"
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import moment from "moment";
import getSymbolFromCurrency from "currency-symbol-map";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
// import {
//     MuiPickersUtilsProvider,
//     DatePicker
// } from "@mui/material/pickers";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import {
    Alert, Row,
    Col,
    Card
} from "reactstrap";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import { getTransactionListsRefund } from "../../redux/actions/getTransactionListRefundAction";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import val from "../../getThemeDetails";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminRefund = () => {
    const [trackingId, settrackingId] = useState('');
    const [partnerId, setpartnerId] = useState('');
    const [merchantId, setmerchantId] = useState('');
    const [orderId, setorderId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
    const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);

    const [reverseBtnAction, setReverseBtnAction] = useState(false);
    const [getRefundStatus, setGetRefundStatus] = useState(false);
    const [RefundArray, setRefundListArray] = useState([]);
    const [getRemark, setGetRemark] = useState("");
    const [refundAmount, setRefundAmount] = useState("");

    const [notificationRefundOpen, setNotificationRefundOpen] =
        React.useState(false);
    const [openReverse, setOpenReverse] = React.useState(false);

    const getRefundRes = useSelector(
        ({ partnerGetRefundList }) => partnerGetRefundList
    );
    const classes = useStyles();
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [pageNo, setPageNo] = useState(0)
    // const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(5);


    var date = new Date();
    const [selectedDate, setSelectedDate] = useState(
        new Date(date.getFullYear(), date.getMonth(), 1)
    );

    console.log(selectedDate, "Refund_date");
    const [selectedToDate, setSelectedToDate] = useState(new Date());
    console.log(selectedToDate, "Refund_date1");

    const handleChangeEvent=(e)=>{
        const { value } = e.target;
        if (/^\d*$/.test(value)) {
          setRefundAmount(value);
        }
    }
    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'trackingId') {
            settrackingId(value);
        }
        if (name === 'partnerId') {
            setpartnerId(value);
        }
        if (name === 'merchantId') {
            setmerchantId(value);
        }
        if (name === 'orderId') {
            setorderId(value);
        }
        if (name === "refundAmount") {
            console.log("VALUESSSS", value)
            setRefundAmount(value);
        }
        if (name === "getRemark") {
            console.log("VALUESSSS", value)
            setGetRemark(value);
        }
    };
    const handleChangePageForward = (pageaa, newPage) => {
        setPageNo(newPage);

        // getWalletTransactionListReq()
        console.log("Arrow", newPage)
    };

    const handleChangeRowsPerPage = (event) => {

        setRowsPerPage(parseInt(event.target.value));
        setPageNo(0);

    };
    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    // };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    // };
    const handleClose = () => {
        setOpenReverse(false)
        setReverseBtnAction(false);



    }
    const handleNoticationClose = () => {
        setNotificationRefundOpen(false)


    };
    const [getTransListRefundStatus, setGetTransListRefundStatus] = useState(false);
    const [getTransRefundListArray, setGetTransRefundListArray] = useState([]);


    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );

    const getTransactionListRefundRes = useSelector(
        ({ partnerGetTransactionListsRefunds }) => partnerGetTransactionListsRefunds
    );
    const getWalletOwnerIdRes = useSelector(
        ({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
    );
    const dispatch = useDispatch();

    var authToken = regenerateTokenRes.data.AuthToken;


    const getWalletOwnerIdStatusFunc = () => {
        if (getWalletOwnerIdStatus) {
            if (getWalletOwnerIdRes.data.status == "success") {
                setGetWalletOwnerIdResArray(
                    [].concat(getWalletOwnerIdRes.data.ownerList)
                );
            }
            if (getWalletOwnerIdRes.data.status == "failed") {
                setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
                if (
                    getWalletOwnerIdRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getWalletOwnerIdRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId || localStorage.getItem("walletOwnerId"));
                }
            }
            if (getWalletOwnerIdRes.data.status == "NOT FOUND") {
                setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
                if (
                    getWalletOwnerIdRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getWalletOwnerIdRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    const getWalletOwnerIdAndNameListReq = () => {
        setGetWalletOwnerIdStatus(true);
        dispatch(
            getWalletOwnerIdAndNameList(
                {
                    loginDetails: {
                        // adminId: "2"
                        adminId:val.adminIDS
                    }
                },
                authToken
            )
        );
    };
    useEffect(() => {
        // if (regenerateTokenRes.data.status == "success") {

        getWalletOwnerIdAndNameListReq();
        // }
    }, [regenerateTokenRes.data.AuthToken]);

    useEffect(() => {
        getWalletOwnerIdStatusFunc();
    }, [getWalletOwnerIdRes.data.status]);

    const getTransactionListReq = () => {
        setIsLoading(true);

        setGetTransListRefundStatus(true);
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: partnerId == "Select Owner Id" ? "" : partnerId.split("-")[0],
                transactionId: trackingId,
                customerId: merchantId,
                orderDescription: orderId,
                fromDate: moment(selectedDate).format("YYYY-MM-DD"),
                toDate: moment(selectedToDate).format("YYYY-MM-DD"),
                page: pageNo + 1,
                record: rowsPerPage

            }
        };
        // console.log("refundList", req)
        dispatch(getTransactionListsRefund(req, authToken));
    };
    useEffect(() => {
        if (getTransactionListRefundRes.data.status) {

            getTransactionListFunc();
        }

    }, [getTransactionListRefundRes]);
    // useEffect(() => {
    //     getTransactionListFunc();
    // }, [getTransactionListRefundRes.data.status]);
    useEffect(() => {
        if (partnerId) {
            getTransactionListReq();
        }
    }, [pageNo, rowsPerPage])

    const getTransactionListFunc = () => {
        if (getTransListRefundStatus) {
            if (getTransactionListRefundRes.data.status === "success") {

                setGetTransRefundListArray([].concat(getTransactionListRefundRes.data.customerMasterDetailsRequestVOList));
                setIsLoading(false);

            }
            if (getTransactionListRefundRes.data.status === "failed") {

                setGetTransRefundListArray(getTransactionListRefundRes.data);
                setIsLoading(false);
                NotificationPopups(
                    "error",
                    "Failed",
                    getTransactionListRefundRes.data.description ||
                    getTransactionListRefundRes.description
                );
                if (
                    getTransactionListRefundRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getTransactionListRefundRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getTransactionListRefundRes.data.status === "Failed") {

                setGetTransRefundListArray(getTransactionListRefundRes.data);
                setIsLoading(false);
                NotificationPopups(
                    "error",
                    "Failed",
                    getTransactionListRefundRes.data.description ||
                    getTransactionListRefundRes.description
                );
                if (
                    getTransactionListRefundRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getTransactionListRefundRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getTransactionListRefundRes.data.status === "Not Found") {

                setGetTransRefundListArray(getTransactionListRefundRes.data);
                setIsLoading(false);
                NotificationPopups(
                    "error",
                    "NOT FOUND",
                    getTransactionListRefundRes.data.status
                );

                if (
                    getTransactionListRefundRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getTransactionListRefundRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };
    useEffect(() => {
        if (getTransactionListRefundRes.data.status == "success") {
            // setPageNo(0);
        }
    }, [getTransactionListRefundRes.data.status]);
    const [refundData, setRefundData] = useState({
        customerId: "",
        transactionId: "",
        amount: "",
        currency: "",
        transactionType: "",
        storeId: "",
        dealerId: "",
        dsrId: "",
        initiatedBy: ""
    });
    const {
        customerId,
        transactionId,
        initiatedBy,
        dsrId,
        dealerId,
        storeId,
        transactionType,
        currency,
        amount

    } = refundData

    const ReverseDataFunc = (currency, toCustId, id) => {




        setRefundData({
            ...refundData,
            customerId: toCustId,
            walletOwnerId: partnerId == "Select Owner Id" ? "" : partnerId.split("-")[0],
            transactionId: id,
            amount: "",
            currency: currency,
            transactionType: "RF",
            storeId: "",
            dealerId: "",
            dsrId: "",
            initiatedBy: "Admin"
        })
        setReverseBtnAction(true)
    }

    // const sendRefundReq = () => {
    //     setGetRefundStatus(true)
    //     setReverseBtnAction(false)

    //     // setNotificationRefundOpen(false)
    //     const request = {
    //         actionCustomerMasterRequestVO: refundData
    //     }
    //     dispatch(getRefunds(request, authToken));
    //     console.log("requestttss", request)


    // }

    const sendRefundReq = () => {
        setGetRefundStatus(true)
        setReverseBtnAction(false)

        // setNotificationRefundOpen(false)
        const request = {
            actionCustomerMasterRequestVO: { ...refundData, remark: getRemark || "", amount: refundAmount || "" }

        }
        dispatch(getRefunds(request, authToken));
        setGetRemark('')
        setRefundAmount('')

        console.log("requestttss", request)


    }

    const sendRefundFunc = () => {
        console.log("REFUNDSSSSDD", getRefundRes)
        if (getRefundStatus) {
            if (getRefundRes.data.status === "success" || getRefundRes.data.status === "Success") {
                setRefundListArray(getRefundRes.data);

                setNotificationRefundOpen(true)

            }
            if (getRefundRes.data.status === "Failed") {
                console.log("FAILES statussss")
                console.log("POPup", getRefundRes.data)

                setRefundListArray(getRefundRes.data);
                setNotificationRefundOpen(true)

                if (
                    getRefundRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getRefundRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getRefundRes.data.status === "failed") {


                setRefundListArray(getRefundRes.data);
                setNotificationRefundOpen(true)

                if (
                    getRefundRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getRefundRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }
    useEffect(() => {
        sendRefundFunc();
    }, [getRefundRes]);

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleToDateChange = (date) => {
        setSelectedToDate(date);
    };

    // useEffect(() => {
    //     if (regenerateTokenRes.data.status == "success") {
    //         getTransactionListReq();
    //     }
    // }, [regenerateTokenRes.data.status]);



    // const submitfunction = (e) => {
    //     const req = {
    //         trackingId: trackingId,
    //         partnerId: partnerId,
    //         merchantId: merchantId,
    //         orderId: orderId,
    //     }
    //     console.log("Req: ", req);
    // };

    // const reverseFunc = () => {
    //     console.log('Button Clicked !!!')
    // }

    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <FormControl fullWidth>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="From Date"
                                        format="MM/dd/yyyy"
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        disableFuture={true}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <FormControl fullWidth>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="To Date"
                                        format="MM/dd/yyyy"
                                        value={selectedToDate}
                                        onChange={handleToDateChange}
                                        disableFuture={true}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <TextField
                                className='removeArrows'
                                size="small"
                                color="primary"
                                variant="standard"
                                type="number"
                                label="Transaction ID"
                                fullWidth={true}
                                name="trackingId"
                                value={trackingId}
                                onChange={handleChange}
                            ></TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <TextField
                                required
                                select
                                size="small"
                                color="primary"
                                variant="standard"

                                type="text"
                                label="Owner ID"
                                fullWidth={true}
                                name="partnerId"
                                // value={walletOwnerId}
                                defaultValue={partnerId || "Select Owner Id"}
                                onChange={handleChange}

                            >
                                {/* <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem> */}
                                {/* {console.log("GETARRAYowner", getWalletOwnerIdResArray)} */}
                                {/* {getWalletOwnerIdRes.data.ownerList &&
                                    getWalletOwnerIdResArray && [].concat(getWalletOwnerIdResArray).map((x) => (
                                        <MenuItem value={x.split("-")[0]}>{x}</MenuItem>
                                    ))} */}
                                <MenuItem value="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {getWalletOwnerIdRes.data.ownerList &&
                                    getWalletOwnerIdResArray && [].concat(getWalletOwnerIdResArray).map((x) => {
                                        if (typeof x === 'string') {
                                            return <MenuItem key={x} value={x.split("-")[0]}>{x}</MenuItem>;
                                        } else {
                                            console.error('Expected string but got:', x);
                                            return null;
                                        }
                                    })}
                            </TextField>
                        </Grid>
                        {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Partner ID"
                                fullWidth={true}
                                name="partnerId"
                                defaultValue={"Select Partner Id" || partnerId}
                                // onChange={(e) => onInputChange(e, "alphabet")}
                                onChange={handleChange}
                            >
                                <MenuItem selected="Select Partner Id" value="Select Partner Id">Select Partner Id</MenuItem>
                                <MenuItem value="1">1-M-Transact</MenuItem>
                                <MenuItem value="14">14-Takapaysa</MenuItem>
                                <MenuItem value="110">110-Absa</MenuItem>
                            </TextField>
                        </Grid> */}

                        {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                            <TextField
                                className='removeArrows'
                                size="small"
                                color="primary"
                                type="number"
                                label="Merchant ID"
                                fullWidth={true}
                                name="merchantId"
                                value={merchantId}
                                // onChange={(e) => onInputChange(e, "number")}
                                onChange={handleChange}
                            ></TextField>
                        </Grid> */}

                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <TextField
                                // className='removeArrows'
                                size="small"
                                color="primary"
                                variant="standard"

                                type="text"
                                label="Order ID"
                                fullWidth={true}
                                name="orderId"
                                value={orderId}
                                // onChange={(e) => onInputChange(e, "number")}
                                onChange={handleChange}
                            ></TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    marginLeft: "15px"
                                }}
                                onClick={getTransactionListReq}
                            >
                                Search <SearchIcon />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>


                {isLoading ? (
                    <LoadingSpinner />
                ) : getTransRefundListArray.length == undefined ||
                    getTransRefundListArray.status == "NOT FOUND" ||
                    getTransRefundListArray.status == "Failed" ||
                    !getTransListRefundStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                    // style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography
                                        variant="body1"
                                        style={{ fontWeight: "700" }}
                                        className="themeText"
                                    >
                                        Refund Details
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="my-3">
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">

                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Transaction Date{" "}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    {" "}
                                                    Customer ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    {" "}
                                                    Transaction ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    {" "}
                                                    Order ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Captured Amount
                                                </TableCell>

                                                {/* <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Refunded Amount
                                        </TableCell> */}
                                                {/* <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Currency
                                                </TableCell> */}
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Status
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Remark
                                                </TableCell>
                                                {/* <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Action
                                        </TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getTransRefundListArray &&
                                                []
                                                    .concat(getTransRefundListArray)
                                                    // .slice(
                                                    //     page * rowsPerPage,
                                                    //     page * rowsPerPage + rowsPerPage
                                                    // )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>

                                                            <TableCell align="center">
                                                                {row.registeredTime}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.fromCustId}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.id}
                                                            </TableCell>

                                                            {/* <TableCell align="center">{row.verifyStatus}</TableCell> */}
                                                            <TableCell align="center">{row.orderDescription}</TableCell>

                                                            <TableCell align="center">
                                                                {getSymbolFromCurrency(row.currency) +
                                                                    " " + row.amount}
                                                            </TableCell>
                                                            {/* <TableCell align="center">{row.currency}</TableCell> */}
                                                            <TableCell align="center">{row.status}</TableCell>
                                                            <TableCell align="center">
                                                                <Tooltip title="Reverse">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "10px"
                                                                    }}
                                                                    onClick={() =>
                                                                        ReverseDataFunc(

                                                                            row.currency,
                                                                            row.toCustId,
                                                                            row.id,
                                                                        )
                                                                    }


                                                                >
                                                                    <RotateLeftIcon />

                                                                </CustomButton>
                                                                </Tooltip>
                                                            </TableCell>




                                                        </TableRow>
                                                    ))}
                                        </TableBody>

                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={getTransactionListRefundRes.data.count}
                                        page={pageNo}
                                        rowsPerPage={rowsPerPage}
                                        onPageChange={handleChangePageForward}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        // handleChangeRowsPerPage={handleChangeRowsPerPage}

                                    // page={page}
                                    // onChangePage={handleChangePage}
                                    // onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />

                                </TableContainer>

                            </Grid>
                        </Card>
                    </div>
                )}

                <div>
                    <Dialog open={reverseBtnAction} onClose={handleClose}>
                        {/* <DialogTitle> Do you really want to Refund?</DialogTitle> */}
                        <DialogTitle style={{ width: "400px" }}>Refund Transaction</DialogTitle>


                        <DialogContent>
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Refund Amount*"
                                name="refundAmount"
                                type="text"
                                fullWidth
                                variant="standard"
                                onChange={handleChangeEvent}

                                // onChange={handleChange}
                                value={refundAmount}
                            />
                            <p>Please provide reason for refund</p>
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Refund Reason*"
                                name="getRemark"
                                type="text"
                                fullWidth
                                variant="standard"
                                onChange={handleChange}
                                value={getRemark || ""}
                            />

                            <p style={{ marginTop: "12px" }}>
                                Do you really want to Reverse the Transaction?
                            </p>


                        </DialogContent>
                        <DialogActions>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleClose}
                            >
                                No
                            </CustomButton>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                disabled={!getRemark}
                                onClick={sendRefundReq}
                            >
                                Yes
                            </CustomButton>

                        </DialogActions>
                    </Dialog>
                </div>




                {/* <div>
                    <Dialog open={openReverse} onClose={handleClose}>
                        <DialogTitle style={{ width: "400px" }}>
                            Do you really want to reverse this transaction?
                        </DialogTitle>
                        <DialogActions className="p-3">
                            <CustomButton
                                style={{
                                    // backgroundColor: "#fff",
                                    // color: "#000",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleClose}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    // backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={sendReversalInfo}
                            >
                                OK
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div> */}
            </Layout>

            {(RefundArray.status == "success" || RefundArray.status == "Success") && (
                <div>
                    <Dialog
                        open={notificationRefundOpen}
                        onClose={handleNoticationClose}
                    >
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {RefundArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
            {RefundArray.status == "Failed" && (
                <div>
                    <Dialog
                        open={notificationRefundOpen}
                        onClose={handleNoticationClose}
                    >
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {RefundArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
            {RefundArray.status == "failed" && (
                <div>
                    <Dialog
                        open={notificationRefundOpen}
                        onClose={handleNoticationClose}
                    >
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {RefundArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}


        </>
    );
};

export default AdminRefund;
